import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';

export const Layout: React.FC = () => {
  return (
    <div className="relative min-h-screen bg-background text-foreground">
      {/* Faint brand wash at the top — the only decoration on the app canvas */}
      <div
        aria-hidden
        className="pointer-events-none fixed inset-x-0 top-0 -z-10 h-[420px] bg-[radial-gradient(ellipse_at_top,color-mix(in_oklab,var(--primary)_15%,transparent),transparent_65%)]"
      />

      <Header />
      <main className="relative z-10">
        <Outlet />
      </main>
    </div>
  );
};
